import {
  BreakpointsEnum,
  ButtonType,
  CaesarsButton,
  isBreakpointDown,
  useBreakpoint,
  useIsWeb,
} from '@eCommerce/frontend-legacy-shared-library-native';
import {Modal, Text, View, useTheme} from 'native-base';
import React, {ReactElement} from 'react';
import {SafeAreaView} from 'react-native-safe-area-context';
import Icon from 'react-native-vector-icons/FontAwesome5Pro';

/**
 * Full-screen modal that displays a warning box in the center
 * which can have a primary and a secondary CTA
 */
export interface WarningModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string | ReactElement;
  body?: string | ReactElement;
  primaryCTATitle: string;
  secondaryCTATitle?: string;
  onPrimaryPress: () => void;
  onSecondaryPress?: () => void;
  isSecondaryRightAligned?: boolean;
  equallySpacedButtons?: boolean;
}

const WarningModal: React.FC<WarningModalProps> = props => {
  const {
    isOpen,
    onClose,
    onPrimaryPress,
    onSecondaryPress,
    title,
    body,
    primaryCTATitle,
    secondaryCTATitle,
    isSecondaryRightAligned,
    equallySpacedButtons,
  } = props;
  const breakpoint = useBreakpoint();
  const isXSScreen = isBreakpointDown(breakpoint, BreakpointsEnum.XS);
  const theme = useTheme() as any;
  const {tuna, error, caesarRewards, athens} = theme.colors;
  const isWeb = useIsWeb();

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      height="100%"
      bgColor={isXSScreen ? '#FFFFFF' : '#F7F7F8'}>
      <SafeAreaView
        style={{
          height: '100%',
          width: '100%',
          backgroundColor: isXSScreen ? '#FFFFFF' : '#F7F7F8',
        }}>
        <View
          justifyContent="center"
          alignItems="center"
          bgColor={isXSScreen ? '#FFFFFF' : '#F7F7F8'}
          width="100%"
          flexDirection="column"
          px={isXSScreen ? '24px' : '16px'}
          flex={1}>
          <View
            alignItems="flex-end"
            width="100%"
            height="100%"
            position="absolute"
            paddingTop={isXSScreen ? '24px' : '16px'}
            paddingRight={isXSScreen ? '24px' : '16px'}>
            <Icon
              name="times"
              size={theme.fontSizes[8]}
              color={tuna}
              light
              onPress={onClose}
            />
          </View>
          <View
            justifyContent="center"
            alignItems="center"
            bgColor={isXSScreen ? '#FFFFFF' : '#F7F7F8'}>
            <View
              width={isXSScreen ? '100%' : '600px'}
              height={isXSScreen ? '100%' : '378px'}
              backgroundColor="white"
              borderRadius={isXSScreen ? null : '8px'}
              padding={isXSScreen ? '16px' : '64px'}
              justifyContent="center"
              alignItems="center"
              shadow={!isXSScreen ? 1 : null}>
              <Icon
                name="exclamation-triangle"
                color={error}
                size={64}
                light
                selectable={false}
                style={{paddingBottom: 24}}
              />
              {!!title && (
                <Text
                  paddingBottom="24px"
                  fontFamily="heading"
                  fontSize="24px"
                  fontWeight="bold"
                  lineHeight="28px"
                  color={tuna}
                  textAlign={'center'}
                  textTransform="uppercase">
                  {title}
                </Text>
              )}
              {!!body && (
                <Text
                  fontFamily="body"
                  fontSize="14px"
                  lineHeight="24px"
                  color={tuna}
                  textAlign="center">
                  {body}
                </Text>
              )}
              {!isXSScreen ? (
                <View
                  paddingTop="32px"
                  width="100%"
                  flexDirection="row"
                  alignItems="center"
                  justifyContent={
                    !secondaryCTATitle
                      ? 'center'
                      : isSecondaryRightAligned
                        ? 'flex-end'
                        : 'space-between'
                  }>
                  {!!secondaryCTATitle && (
                    <View
                      paddingRight={4}
                      flex={equallySpacedButtons ? 1 : undefined}>
                      <CaesarsButton
                        title={secondaryCTATitle}
                        onPress={onSecondaryPress}
                        type={ButtonType.TEXT_CTA}
                        color={caesarRewards}
                        isFullWidth
                      />
                    </View>
                  )}
                  <View flex={1}>
                    <CaesarsButton
                      title={primaryCTATitle}
                      onPress={onPrimaryPress}
                      type={ButtonType.PRIMARY}
                      color={caesarRewards}
                      isFullWidth
                    />
                  </View>
                </View>
              ) : null}
            </View>
          </View>
        </View>
        {isXSScreen ? (
          <View
            padding="16px"
            maxHeight="112px"
            width="100%"
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            justifySelf={isWeb ? 'flex-end' : undefined}
            borderTopColor={athens}
            borderTopWidth="1px">
            <CaesarsButton
              title={primaryCTATitle}
              isFullWidth={true}
              onPress={onPrimaryPress}
              type={ButtonType.PRIMARY}
              color={caesarRewards}
            />
            {!!secondaryCTATitle && (
              <>
                <View height="8px" width="100%" />
                <CaesarsButton
                  title={secondaryCTATitle}
                  type={ButtonType.TEXT_CTA}
                  isFullWidth={true}
                  onPress={onSecondaryPress}
                  color={caesarRewards}
                />
              </>
            )}
          </View>
        ) : null}
      </SafeAreaView>
    </Modal>
  );
};

export default WarningModal;
